"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TODO = exports.PRE_BUILD_TODO = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
exports.PRE_BUILD_TODO = (0, client_1.gql) `
  query PreBuildTodo(
    $topicIds: [Int!]
    $conceptIds: [Int!]
    $search: String
    $source: String!
    $entitlementId: Int
  ) {
    restricted {
      preBuildTodo(
        topicIds: $topicIds
        conceptIds: $conceptIds
        search: $search
        source: $source
        entitlementId: $entitlementId
      ) {
        unseen
        seen
        buildRef
      }
    }
  }
`;
exports.TODO = (0, client_1.gql) `
  ${fragments_1.CHAPTER_FIELDS}
  ${fragments_1.PICTURE_FIELDS}
  query Todo($id: Int!) {
    restricted {
      todo(id: $id) {
        id
        dailyTask
        source
        marks {
          id
          cardId
          score
          timeTaken
          card {
            question
            explanation
            concept {
              id
              name
              topic {
                id
                name
                typeId
              }
              videos {
                id
                title
                museId
                thumbnail
                concepts {
                  id
                  name
                }
                live
                description
                duration
              }
              chapter {
                ...ChapterFields
              }
            }
            pictures {
              ...PictureFields
            }
          }
        }
      }
    }
  }
`;
